import { useState, useCallback } from 'react'
import { RequestService } from '../services/RequestService'

const useEmployeeKPIs = () => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState(null)

  const fetchData = useCallback(async ({ employeeId }) => {
    setLoading(true)

    try {
      const { data } = await RequestService.getEmployeeKPIs({ employeeId })

      setData(data)
    } catch (e) {
      console.log('useEmployeeKPIs', e)
    }
    setLoading(false)
  }, [])

  return { loading, data, fetchData }
}

export default useEmployeeKPIs
